<template>
    <div class="c-loading">
        <div class="c-loading--inner">
            <div class="sphere" v-for="i in 13" :key="i"></div>
        </div>
    </div>
</template>

<script>
export default {
    name : "Loading"
};
</script>

<style lang="scss" scoped>
    .c-loading {
        position: fixed;
        z-index: 555;
        top: 0vh;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba($color: white, $alpha:.8);

        &--inner {
            position: absolute;
            top : 40%;
            left : 50%;
            width : 50vw;
            margin-left : -25vw;
            text-align: center;
            display: flex;
            justify-content: center;

            .sphere {
                background : $color-blue;
                border-radius: 50%;
                width : 1.4rem;
                height: 1.4rem;
                animation: sphere 1s infinite;
                animation-direction: alternate;
                animation-fill-mode: forwards;
                margin : 0 .2rem;

                @for $i from 1 through 13 {
                    &:nth-child(#{$i}) {
                        animation-delay: math.div($i, 10)s;
                    }
                }
            }
        }
    }

    @keyframes sphere {
        from {margin-top: 0}
        to {margin-top: 1.2rem}
    }
</style>